import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { getPlatformExportDescriptor } from '@app/modules/social-export/domain/platform-export-descriptors';
import { DefaultPlatformConnect } from '../DefaultPlatformConnect';

type Props = {
  platform: SocialPlatform;
};

/**
 * Platform-specific connect UI for client-level OAuth / API-key flows.
 */
export function PlatformConnectFactory({ platform }: Props) {
  const { Connect } = getPlatformExportDescriptor(platform);
  if (Connect) {
    return <Connect />;
  }
  return <DefaultPlatformConnect platform={platform} />;
}
